import React from 'react';
import useIsMobile from 'utils/hooks/useIsMobile';
import clsx from 'clsx';
import { imageUrl } from 'theme';

interface OwnProps {
  title: string;
  description: string;
  onClick: () => void;
  isCompleted: boolean;
}

const CtaCard = (props: OwnProps) => {
  const { title, description, onClick = () => {}, isCompleted = false } = props;
  const isMobile = useIsMobile();

  return (
    <div
      className={clsx(
        'cursor-pointer p-2 rounded',
        isMobile && 'min-w-[184px]',
        isCompleted ? 'bg-neutral-200' : 'bg-neutral-100',
      )}
      onClick={onClick}
    >
      <div className="flex gap-2">
        {isCompleted ? (
          <img
            className="mt-[2px]"
            height={16}
            width={16}
            src={imageUrl.checkbox}
            alt="checkbox"
          />
        ) : (
          <span aria-label="light-bulb" role="img">
            👉
          </span>
        )}
        <div className="flex flex-col gap-1">
          <p
            className={clsx(
              'text-sm font-bold',
              isCompleted ? 'text-neutral-500' : 'text-neutral-700',
            )}
          >
            {title}
          </p>
          <p
            className={clsx(
              'text-xs font-normal',
              isCompleted ? 'text-neutral-500' : 'text-neutral-600',
            )}
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CtaCard;
